import { ROUTES } from '@/constants'
import { PERMISSIONS } from '@/services/permissions'
import {
  CalendarMonth as CalendarIcon,
  LocalHospital as ClinicsIcon,
  Dashboard as DashboardIcon,
  Inventory as InventoryIcon,
  People as PeopleIcon,
  Assignment as PlanIcon,
  CreditCard as SubscriptionIcon,
  ManageAccounts as UsersIcon,
  MedicationLiquidOutlined as RxIcon,
} from '@mui/icons-material'
import AddTaskOutlinedIcon from '@mui/icons-material/AddTaskOutlined'
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined'
import MedicalServicesOutlinedIcon from '@mui/icons-material/MedicalServicesOutlined'
import type { SidebarNavItem } from './Sidebar'

/**
 * The clinician-portal menu, in order. Each item carries the permission of the page it opens;
 * the layout filters it for the signed-in role and the landing redirect picks the first item left.
 */
export const CLINICIAN_NAV_ITEMS: SidebarNavItem[] = [
  {
    to: ROUTES.APP.DASHBOARD,
    icon: <DashboardIcon />,
    label: 'Dashboard',
    end: true,
    permission: PERMISSIONS.DASHBOARD_DASHBOARD_VIEW,
  },
  {
    to: ROUTES.APP.CLINICS,
    icon: <ClinicsIcon />,
    label: 'Clinics',
    permission: PERMISSIONS.CLINIC_CLINIC_VIEW,
  },
  {
    to: ROUTES.APP.USERS,
    icon: <UsersIcon />,
    label: 'Users',
    permission: PERMISSIONS.USERS_USER_VIEW,
  },
  {
    to: ROUTES.APP.CLIENTS,
    icon: <PeopleIcon />,
    label: 'Patients',
    permission: PERMISSIONS.PATIENTS_PATIENT_VIEW,
  },
  {
    to: ROUTES.APP.APPOINTMENTS,
    icon: <CalendarIcon />,
    label: 'Appointments',
    permission: PERMISSIONS.SCHEDULING_APPOINTMENT_VIEW,
  },
  {
    to: ROUTES.APP.ENCOUNTERS,
    icon: <MedicalServicesOutlinedIcon />,
    label: 'Encounters',
    permission: PERMISSIONS.ENCOUNTERS_ENCOUNTER_VIEW,
  },
  {
    to: ROUTES.APP.TASKS,
    icon: <AddTaskOutlinedIcon />,
    label: 'Task',
    permission: PERMISSIONS.TASKS_TASK_VIEW,
  },
  {
    to: ROUTES.APP.SUBSCRIPTIONS,
    icon: <SubscriptionIcon />,
    label: 'Subscriptions',
    permission: PERMISSIONS.SUBSCRIPTIONS_SUBSCRIPTION_VIEW,
  },
  { to: ROUTES.APP.PRESCRIPTIONS, icon: <RxIcon />, label: 'Prescriptions' },
  {
    to: ROUTES.APP.INVENTORY,
    icon: <InventoryIcon />,
    label: 'Inventory',
    permission: PERMISSIONS.INVENTORY_INVENTORY_VIEW,
  },
  // { to: ROUTES.APP.SUPERBILLS, icon: <SuperbillIcon />, label: 'Superbills' },
  // Advocate worklist — the key is held by Patient Advocate (and admins) only.
  {
    to: ROUTES.APP.PLAN_OF_CARE,
    icon: <PlanIcon />,
    label: 'Plan of Care',
    permission: PERMISSIONS.COMMERCIAL_PLAN_PLAN_ADVOCATE,
  },
  {
    to: ROUTES.APP.REPORTS,
    icon: <AssessmentOutlinedIcon />,
    label: 'Reports',
    permission: PERMISSIONS.REPORTS_FINANCIAL_VIEW,
  },
  // { to: ROUTES.APP.AFFILIATES, icon: <AffiliateIcon />, label: 'Affiliates' },
]
